import { StripeElements } from "@Light/components/page/payment/StripeElements";
import { captureMessage } from "@sentry/react";
import { useEffect, useState } from "react";
import { useEnrollment } from "../flow/context";
import { maybeRequirementValue } from "../flow/screen";
import { PaymentMethodForm } from "./PaymentMethodForm";
import type { ExpressPaymentMethod, PaymentMethod } from "./PaymentOptions";

// Time limit before we stop waiting for Stripe to report express checkout
// payment options and just fall back to credit card.
const STRIPE_PAYMENT_METHOD_TIMEOUT_MS = 5000;

export const PaymentSetup = () => {
  const { requirements } = useEnrollment();
  const existingCard = maybeRequirementValue(requirements.payment_method)?.card;

  const [paymentSessionKey, setPaymentSessionKey] = useState(0);
  const [option, setOption] = useState<PaymentMethod | undefined>(
    existingCard ? "existing" : undefined,
  );
  const [expressMethods, setExpressMethods] = useState<
    ExpressPaymentMethod[] | undefined
  >(undefined);

  useEffect(() => {
    if (expressMethods !== undefined) return;
    const timer = setTimeout(() => {
      captureMessage("Express checkout availability timed out");
      setExpressMethods([]);
    }, STRIPE_PAYMENT_METHOD_TIMEOUT_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [expressMethods]);

  return (
    <StripeElements key={paymentSessionKey}>
      <PaymentMethodForm
        existingCard={existingCard}
        option={option}
        onOptionChange={setOption}
        expressPaymentMethods={expressMethods}
        onExpressPaymentMethodsAvailable={setExpressMethods}
        onExpressCheckoutError={() => {
          setPaymentSessionKey((key) => key + 1);
        }}
      />
    </StripeElements>
  );
};
